$(function () {
	//nothing
	initDatepicker();
	initSelect2();
	initTabs();
})

function initForDialog(parent) {
	initValidationForm(parent);
	initIcheck(parent);
	initSlimScrolls(parent);
	initConfirmAction(parent);
	initDatepicker(parent);
	initSelect2(parent);
}

/* *** */
function initSelectAllCheck(masterCheck, parentForChecks, nameChecks) {
	masterCheck.on("change", function () {
		var checked = $(this).is(":checked");

		$("input[type=checkbox]", parentForChecks).each(function (i, e) {
			if ($(e).is("[name=" + nameChecks + "]")) {
				$(e).prop('checked', checked);
				$(e).icheck('updated');
			}
		})
	})
}

/* *** */
function initEnableButtonWhenChecked(checks, button) {
	checks.on("ifChanged", function () { _updateEnableButtonWhenChecked(checks, button); });
	_updateEnableButtonWhenChecked(checks, button);
}

function _updateEnableButtonWhenChecked(checks, button) {
	var checkedSome = false;

	checks.each(function (i, e) {
		if ($(e).is(":checked")) checkedSome = true;
	})

	if (checkedSome) button.attr("disabled", false);
	else button.attr("disabled", true);

}

/* *** */
function initMenuSaveState(parent, groupName, className) {
	if (groupName == null || typeof (groupName) == "undefined") groupName = "default";
	if (className == null || typeof (className) == "undefined") className = "active";

	//console.debug("[save-state] groupName: " + groupName);
	//console.debug("[save-state] className: " + className);

	groupName += "_save_state_";

	$("[menu-save-state]", parent).each(function (i, e) {
		var cookieName = groupName + $(e).attr("menu-save-state");

		var state = Cookies.get(cookieName)
		if (state == 1) {
			$(e).addClass(className);
			$(".collapse:first", e).addClass("in");
		}

		$(e).on("cssClassChanged", function () {
			if ($(this).hasClass(className)) Cookies.set(cookieName, 1);
			else Cookies.remove(cookieName);
		});
	});
}

/* *** */
function initIcheck(parent) {
	if (parent == null || typeof (parent) == "undefined") parent = $("body");
	$('.i-checks', parent)
		/*.on('ifChanged', function (event) {
			$(event.target).trigger('change');
		})*/
		.icheck({
			checkboxClass: 'icheckbox_square-green',
			radioClass: 'iradio_square-green',
		});
}

/* *** */
function initSlimScrolls(parent) {
	if (parent == null || typeof (parent) == "undefined") parent = $("body");

	$('[slim-scroll]').each(function (i, e) {
		var height = $(e).attr("slim-scroll");

		$(e).slimScroll({
			height: height + "px",
			size: "10px"
		})
	});
}

function initConfirmAction(parent) {
	if (parent == null || typeof (parent) == "undefined") parent = $("body");

	$('[confirm-action]', parent).each(function (i, e) {
		$(e).on("click", function (ev) {
			var msg = $(e).attr("confirm-action");
			var result = confirm(msg);
			
			if (result) return true;
			
			ev.preventDefault();
			return false;
		})
	});
}

function initDatepicker() {
	$('input[datepicker]').datepicker({ language: 'ru', format: "dd.mm.yyyy", autoclose: true });

}

function initSelect2(parent) {
	if (parent == null || typeof (parent) == "undefined") parent = $("body");

	//$('.select2',parent).select2();
	$('.select2,.selectize', parent).selectize();

}

function initTabs(parent) {
	if (parent == null || typeof (parent) == "undefined") parent = $("body");

	$(function () {
		$('a[data-toggle="tab"]', parent).on('shown.bs.tab', function (e) {
			var url = $(e.target).attr("data-remote-tab");
			var target = $(e.target).attr("href");
			if (url != null && typeof (url) != "undefined") {
				$.ajax({
					type: "GET",
					url: url,
					error: function (data) {
						alert("Ошибка");
					},
					success: function (data) {
						$(target).html(data);
						initModalDataToggle($(target));
					}
				})
			}
		})

		var url = document.location.toString();
		if (url.match('#')) {
			$('a[href="#' + url.split('#')[1] +'"]', parent).tab('show');
		} else {
			$('a[data-toggle="tab"]:first', parent).tab('show')
		}

	})
}